import * as React from 'react';

import { RadioGroup, Text } from '@components/common';
import { RadioGroupOption } from '@components/common/RadioGroup';

import DisqualificationPageForm from './DisqualificationPageForm';

const QUALIFICATION_OPTIONS: RadioGroupOption<Study['qualification_screener_review']>[] = [
  {
    label: 'Manual review',
    helper: 'Handpick participants after gathering responses. Defining qualifying answers can make review easier.',
    value: 'manual'
  },
  {
    label: 'Automatic',
    helper: 'Participants who select all qualifying answers can participate or schedule right away.',
    value: 'auto'
  }
];

const DISQUALIFICATION_OPTIONS: RadioGroupOption<Study['disqualification_screener_review']>[] = [
  {
    label: 'Manual review',
    helper: 'Handpick participants after gathering responses. Defining disqualifying answers can make review easier.',
    value: 'manual'
  },
  {
    label: 'Automatic',
    helper: 'Participants who select any disqualifying answer will immediately be sent to the disqualification page.',
    value: 'auto'
  }
];

interface Props {
  qualificationReview: Study['qualification_screener_review'];
  setQualificationReview: (qualificationReview: Study['qualification_screener_review']) => void;
  disqualificationReview: Study['disqualification_screener_review'];
  setDisqualificationReview: (disqualificationReview: Study['disqualification_screener_review']) => void;
  disqualificationPageTitle: string;
  setDisqualificationPageTitle: (value: string) => void;
  disqualificationPageContent: string;
  setDisqualificationPageContent: (value: string) => void;
  disqualificationPageTitleError: boolean | null;
  disqualificationPageContentError: boolean | null;
}

export const PreferencesTab: React.FC<Props> = ({
  qualificationReview,
  setQualificationReview,
  disqualificationReview,
  setDisqualificationReview,
  disqualificationPageTitle,
  setDisqualificationPageTitle,
  disqualificationPageContent,
  setDisqualificationPageContent,
  disqualificationPageTitleError,
  disqualificationPageContentError
}) => {
  return (
    <div className='p-6'>
      <div className='mb-6' key='qualification-section'>
        <Text bold className='mb-2'>
          Qualification
        </Text>
        <RadioGroup<Study['qualification_screener_review']>
          key='qualification-radio-group'
          options={QUALIFICATION_OPTIONS}
          name='screener_config_qualification'
          selected={qualificationReview}
          onChange={setQualificationReview}
        />
      </div>

      <div key='disqualification-section'>
        <Text bold className='mb-2'>
          Disqualification
        </Text>
        <RadioGroup<Study['disqualification_screener_review']>
          key='disqualification-radio-group'
          options={DISQUALIFICATION_OPTIONS}
          name='screener_config_disqualification'
          selected={disqualificationReview}
          onChange={setDisqualificationReview}
        />

        {disqualificationReview === 'auto' && (
          <DisqualificationPageForm
            disqualificationPageTitle={disqualificationPageTitle}
            setDisqualificationPageTitle={setDisqualificationPageTitle}
            disqualificationPageContent={disqualificationPageContent}
            setDisqualificationPageContent={setDisqualificationPageContent}
            disqualificationPageTitleError={disqualificationPageTitleError}
            disqualificationPageContentError={disqualificationPageContentError}
          />
        )}
      </div>
    </div>
  );
};
